import { render } from "./Move.vue?vue&type=template&id=ca8de60c&scoped=true"
import script from "./Move.vue?vue&type=script&lang=js"
export * from "./Move.vue?vue&type=script&lang=js"

import "./Move.vue?vue&type=style&index=0&id=ca8de60c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8de60c"]])

export default __exports__